let menuData = [];
let categoryMenuItems = [];
let featuredCards = [];
let numCards = 0;
let selectedCategory = '';
let numCardOnPage = 0;
let pageWidth = 0;
let cardWidth = 240;
let totalPages = 0;
let currentPage = 1;
let carouselLocation = 0;
const collaterateMenu = "featured_products";

function getProductCardWidth () {
    if ( window.innerWidth >= 1024 ) {
        cardWidth = 240
    } else if ( window.innerWidth >= 768 ) {
        cardWidth = 255
    } else {
        cardWidth = 255
    }
}

function setSelectedPage () {
    document.querySelector('.featuredProductCards-pagination-controls-page').innerHTML = currentPage+'/'+totalPages
}

function featuredCardPageNext () {
    if ( currentPage == totalPages ) {
        currentPage = 1
        setSelectedPage(currentPage)
        carouselLocation = 0
        document.querySelector('.featuredProductCards-view-sled').style.marginLeft = carouselLocation+'px'
        setPageMarker();
    } else {
        currentPage++;
        setSelectedPage(currentPage)
        carouselLocation -=(numCardOnPage * cardWidth)
        document.querySelector('.featuredProductCards-view-sled').style.marginLeft = carouselLocation+'px'
        setPageMarker();
    }
}

function featuredCardPagePrev () {
    if ( currentPage == 1 ) {
        currentPage = totalPages
        setSelectedPage(currentPage)
        carouselLocation -= ((numCardOnPage * cardWidth) * (totalPages - 1))
        document.querySelector('.featuredProductCards-view-sled').style.marginLeft = carouselLocation+'px'
        setPageMarker();
    } else {
        currentPage--
        setSelectedPage(currentPage)
        carouselLocation +=(numCardOnPage * cardWidth)
        document.querySelector('.featuredProductCards-view-sled').style.marginLeft = carouselLocation+'px'
        setPageMarker();
    }
}

function setPageMarker () {
    document.querySelectorAll('.featuredProductCards-pagination-indicator-page').forEach( (e, i) => {
        e.classList.remove('featuredProductCards-pagination-indicator-current')
        if( i+1 == currentPage ) {
            e.classList.add('featuredProductCards-pagination-indicator-current')
        }
    }) 
}

function getPageWidth () {
    pageWidth = document.querySelector('.featuredProductCards-view').offsetWidth
}

function getNumCards () {
    menuData.forEach(e => {
        if(selectedCategory === e.label){
            numCards = e.children.length
        }
    })
}

function getNumCardOnPage () {
    numCardOnPage = (pageWidth - (pageWidth % cardWidth)) / cardWidth
}

function getTotalPages () {
    totalPages = (numCards / numCardOnPage) % 1 ? ((numCards / numCardOnPage) - (numCards / numCardOnPage) % 1) +1 : (numCards / numCardOnPage)
}


function buildPagination () {
    const pages = [] 
    let arrayLengthLoop = 0
    while (arrayLengthLoop < totalPages) {
        if(arrayLengthLoop == 0){
            pages.push('<div class="featuredProductCards-pagination-indicator-page featuredProductCards-pagination-indicator-current"></div>')
        } else {
            pages.push('<div class="featuredProductCards-pagination-indicator-page"></div>')
        }
        arrayLengthLoop++
    }
    document.querySelector('.featuredProductCards-pagination-indicator').innerHTML = pages.join('')
    document.querySelector('.featuredProductCards-pagination-controls-page').innerHTML = currentPage+'/'+totalPages
}

function buildFeaturedCards (selection) {
    menuData.forEach( category => {
        if( category.label == selection ){
            featuredCards = []
            category.children.forEach( item => {
                if(item.label == "Health Care Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/healthcare-saddle-stitch-booklets_3qtr-standing-front_nura.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Nonprofit Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/nonprofit_letter_mailers_with_reply_envelopes_3qtr_standing_side_by_side_env_kinder_nl_re-20240325_013711621.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Church & Religious Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/religious_brochures_3qtr_standing_front_journey_church-20231210_235258550.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Real Estate Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/real_estate_direct_mail_postcards_3qtr_standing_side_by_side_post_aaron-20240715_111258075.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "School Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/school_wire_coil_booklets_3qtr_standing_front_bklt_vantage_campus-20240717_095200882.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Restaurant Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/spiral_coil_menus_3qtr_standing_front_drink-20231120_161109349.jpg?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Senior Living Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/featuredProducts-seniorLiving.jpg" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Brewery Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/featuredProducts-breweries.jpg" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.label == "Winery Printing"){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/featuredProducts-wineries.jpg" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else if(item.thumbUrl.includes('null')){
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://spdc-assets.imgix.net/images/search_result_no_thumbnail_logomark-20240103_141404654.png?w=600&h=500&auto=format,compressed&fit=crop" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                } else {
                    featuredCards.push('<div class="featuredProductCard"><div class="featuredProductCard-title">'+item.label+'</div><a href="'+item.href+'"><div class="featuredProductCard-product"><img src="https://smartpress.imgix.net/'+item.thumbUrl+'" alt="'+item.label+'"/></div></a><div class="featuredProductCard-footer"><a class="btnShop" href="'+item.href+'">Shop Now</a></div></div>')
                }
            })
        }
    })
    document.querySelector('.featuredProductCards-view-sled').innerHTML = featuredCards.join('')
}

function categoryMenuNavigation () {
    document.querySelectorAll('.featuredProductCards-categories-category').forEach( item => {
        item.addEventListener('click', e => {
            buildFeaturedCards(e.target.innerHTML)
            buildCategoryMenuItems(e.target.innerHTML)
            currentPage = 1
            carouselLocation = 0
            document.querySelector('.featuredProductCards-view-sled').style.marginLeft = '0px'
            buildPagination();
        })
    })
}

function buildCategoryMenuItems (category) {
    categoryMenuItems = []
    menuData.forEach( (e) => {
        if(category === e.label){
            categoryMenuItems.push('<li class="featuredProductCards-categories-category featuredProductCards-categories-category_selected">'+e.label+'</li>')
        } else {
            categoryMenuItems.push('<li class="featuredProductCards-categories-category">'+e.label+'</li>')
        }
    })
    document.querySelector('.featuredProductCards-categories').innerHTML = categoryMenuItems.join('')
    categoryMenuNavigation();
}

function buildFeaturedProductCards () {
    getProductCardWidth(); 
    buildCategoryMenuItems(selectedCategory);
    getNumCards();
    getPageWidth();
    getNumCardOnPage();
    getTotalPages();
    buildPagination();
    buildFeaturedCards(selectedCategory);
}

//init featured product cards

Collaterate.Site.getMenuByName(collaterateMenu)
    .then(function (menu) {
        menuData = menu.children
        selectedCategory = menuData[0].label
        buildFeaturedProductCards();
    })
    .catch(function (error){
        document.querySelector('.featuredProductCards').style.display = "none"
        console.warn("Featured Product Card Menu unavaialbe ", error)
        console.warn("Featured Product Card Menu unavaialbe ", error)
        console.warn("Featured Product Card Menu unavaialbe ", error)
    })  


//rebuild on page resize
let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        currentPage = 1
        carouselLocation = 0
        document.querySelector('.featuredProductCards-view-sled').style.marginLeft = '0px'
        selectedCategory = menuData[0].label
        buildFeaturedProductCards();
        resizeTimer = null;
    }, 500); 
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.js--event--featuredCardPagePrev').addEventListener('click',()=>{
         featuredCardPagePrev()
    });
    document.querySelector('.js--event--featuredCardPageNext').addEventListener('click',()=>{
         featuredCardPageNext()
    });
})